import * as React from "react";
import { connect } from "react-redux";

import { RouteComponentProps } from "react-router";
import { Action, Dispatch } from "redux";
import { Client, Role } from "../../domain/model/client";
import { Pager } from "../../domain/model/common";
import { createClientClientsActionCreator } from "../action/client_clients_action";
import ClientClientsComponent from "../component/client/clients/client_clients";
import {
  createClientClientsDispatcher,
  IClientClientsDispatcher,
} from "../dispatcher/client_clients_dispatcher";
import {
  CreateClientByClientRequest,
  DeleteClientByClientRequest,
  GetAllClientsByClientRequest,
  UpdateRoleClientByClientRequest,
} from "../request/clients_request";
import { AppState } from "../store/app_state";
import { AuthState } from "../store/auth_state";
import { ClientClientsState } from "../store/client_clients_state";

const page: number = 1;
const offset: number = 1000;

interface IProps extends RouteComponentProps<{ action: string }> {
  state: ClientClientsState;
  authState: AuthState;
  dispatcher: IClientClientsDispatcher;
}

interface IState {
  isInit: boolean;
  anchorEl: any;
  clientsModalParams: { isVisible: boolean; clientId: string; client?: Client };
}

class ClientClientsContainer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
      anchorEl: null,
      clientsModalParams: { isVisible: false, clientId: "" },
    };
  }

  public componentDidMount(): void {
    const pager: Pager = new Pager(page, offset);
    const req: GetAllClientsByClientRequest =
      new GetAllClientsByClientRequest();
    req.pager = pager;
    this.props.dispatcher.getAllClients(req);
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { match } = this.props;
    const { isLoading, clients } = this.props.state;
    const { anchorEl } = this.state;
    const client: Client | null = this.props.authState.user
      ? this.props.authState.user.client
      : null;
    const myClientId: string = client ? client.id : "";
    // authStateのclientにemailが含まれてないためClient[]から自分を抽出している。
    const myClient: Client | undefined = this.getClientById(myClientId);

    return (
      <ClientClientsComponent
        match={match}
        isLoading={isLoading}
        myClient={myClient}
        clients={clients}
        anchorEl={anchorEl}
        handleCreateSubmit={this.handleCreateSubmit}
        handleClick={this.handleClick}
        handleClose={this.handleClose}
        handleUpdateRoleSubmit={this.handleUpdateRoleSubmit}
        handleClickDelete={this.handleClickDelete}
        clientsModalParams={this.state.clientsModalParams}
        handleClickModalOpen={this.handleClickModalOpen}
        handleClickModalClose={this.handleClickModalClose}
      />
    );
  }

  private handleCreateSubmit = (values: any) => {
    const pager: Pager = new Pager(page, offset);
    const req: CreateClientByClientRequest = new CreateClientByClientRequest();
    req.name = values.name;
    req.nameKana = values.nameKana;
    req.phoneNumber = values.phoneNumber;
    req.position = values.position;
    req.email = values.email;
    req.password = values.password;
    // 現状固定リクエスト
    req.role = Role.Role_Member;
    req.pager = pager;
    this.props.dispatcher.createClient(req);
  };

  private handleClick = (event: any): void => {
    this.setState({ anchorEl: event.currentTarget });
  };

  private handleClose = (): void => {
    this.setState({ anchorEl: null });
  };

  private handleUpdateRoleSubmit = (values: any): void => {
    const role: Role = Number(values.role);
    const clientId: string = values.clientId;

    const pager: Pager = new Pager(page, offset);
    const req: UpdateRoleClientByClientRequest =
      new UpdateRoleClientByClientRequest();
    req.clientId = clientId;
    req.role = role;
    req.pager = pager;
    this.props.dispatcher.updateRoleClient(req);
    this.setState({
      clientsModalParams: {
        isVisible: false,
        clientId: "",
      },
    });
  };

  private handleClickDelete = (
    event: React.MouseEvent<HTMLButtonElement>
  ): void => {
    event.preventDefault();
    const clientId = event.currentTarget.value;
    const pager: Pager = new Pager(page, offset);
    const req: DeleteClientByClientRequest = new DeleteClientByClientRequest();
    req.clientId = clientId;
    req.pager = pager;
    this.props.dispatcher.deleteClient(req);
    this.setState({
      clientsModalParams: {
        isVisible: false,
        clientId: "",
      },
    });
  };

  private handleClickModalOpen = (
    event: React.MouseEvent<HTMLButtonElement>
  ): void => {
    event.preventDefault();
    const value: string = event.currentTarget.value;
    const client = this.getClientById(value);

    this.setState({
      clientsModalParams: {
        isVisible: true,
        clientId: value,
        client,
      },
    });
  };

  private handleClickModalClose = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();

    this.setState({
      clientsModalParams: {
        isVisible: false,
        clientId: "",
      },
    });
  };

  private getClientById = (clientId: string): Client | undefined => {
    const clients: Client[] = this.props.state.clients;
    const filteredClients: Client[] = clients.filter((item: Client) => {
      return item.id === clientId;
    });

    return filteredClients[0];
  };
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientClientsReducer,
    authState: state.authReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientClientsDispatcher(
      dispatch,
      createClientClientsActionCreator()
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientClientsContainer);



// WEBPACK FOOTER //
// ./src/presentation/container/client_clients_container.tsx